import styled, { css } from 'styled-components';

import { variables } from 'app/shared/ui';

const { media } = variables;

export const GridContainerSt = styled.div`
  display: grid;
  grid-gap: 56px;

  ${media.md(css`
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 32px;
    margin: auto;
  `)}

  ${media.lg(
    css`
      max-width: 788px;
      grid-row-gap: 56px;
    `,
  )}

  ${media.xl(
    css`
      max-width: 770px;
    `,
  )}
`;
